import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lg:h-[80px] h-[50px]" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl md:text-6xl uppercase text-center font-bold opacity-100" }, "Services")
], -1)
const _hoisted_5 = { class: "container max-w-[1024px]" }
const _hoisted_6 = { class: "w-full relative flex justify-center items-center md:mt-[50px] mt-[20px]" }
const _hoisted_7 = { class: "container relative w-full md:mt-[10px] mt-[10px] md:mb-[50px] mb-[20px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl my-[20px] font-bold text-center text-cyan-700 uppercase" }, " services ", -1)
const _hoisted_9 = { class: "w-full flex relative" }
const _hoisted_10 = { class: "my-[20px] w-full flex relative justify-center items-center flex-wrap" }

import HeaderComponent from '../components/HeaderComponent.vue'
  import carouselBranding from '../components/CarouselBranding.vue'
  import One_service from '../components/One_service.vue'
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import FooterComponent from '@/components/FooterComponent.vue';
  const initialSlide = 2;
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'servicesFCa',
  setup(__props) {

  const router = useRouter()
  function goToIndividualPage() {
      router.push('/services')
  }
  function goToCompaniePage() {
      router.push('/servicesFC')
  }
  function goToCompanieEPage() {
      router.push('/servicesFCe')
  }
  function goToCompanieAPage() {
      router.push('/servicesFCa')
  }
  function goToMPMEPage() {
      router.push('/servicesMPME')
  }
  const pageTitle = ref('IronSecur | Nos services'); 
  
  onMounted(() => {
      document.title = pageTitle.value; 
  });
  
  const services = ref([
  {   name: 's9_name', 
      image: '/img/service9.jpg', 
      description: 's9_description', 
      key: ["s9_key1", "s9_key2", "s9_key3", "s9_key4", "s9_key5"] 
 
  },
  {   name: 's10_name', 
      image: '/img/service10.jpg', 
      description: 's10_description', 
      key: ["s10_key1", "s10_key2", "s10_key3", "s10_key4", "s10_key5"] 

  },
  {   name: 's11_name', 
      image: '/img/service11.jpg', 
      description: 's11_description', 
      key: ["s11_key1", "s11_key2", "s11_key3", "s11_key4", "s11_key5"] 

  },
  {   name: 's12_name', 
      image: '/img/service12.jpg', 
      description: 's12_description', 
      key: ["s12_key1", "s12_key2", "s12_key3", "s12_key4", "s12_key5"] 

  },
  {   name: 's13_name', 
      image: '/img/service13.jpg', 
      description: 's13_description', 
      key: ["s13_key1", "s13_key2", "s13_key3", "s13_key4", "s13_key5"] 

  },
  {   name: 's14_name', 
      image: '/img/service14.jpg', 
      description: 's14_description', 
      key: ["s14_key1", "s14_key2", "s14_key3", "s14_key4", "s14_key5"] 

  },
  {   name: 's15_name', 
      image: '/img/service15.jpg', 
      description: 's15_description', 
      key: ["s15_key1", "s15_key2", "s15_key3", "s15_key4", "s15_key5"] 

  },
  {   name: 's16_name', 
      image: '/img/service16.jpg', 
      description: 's16_description', 
      key: ["s16_key1", "s16_key2", "s16_key3", "s16_key4", "s16_key5"] 
 
  },
  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(carouselBranding, { "initial-slide": initialSlide }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToIndividualPage())),
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': _ctx.$route.path === '/services'
              })
            }, _toDisplayString(_ctx.$t('FI')), 3),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToCompaniePage())),
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': _ctx.$route.path === '/servicesFCa'
              })
            }, _toDisplayString(_ctx.$t('FOC')), 3),
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToMPMEPage())),
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  'border-cyan-700': _ctx.$route.path === '/servicesMPME'
              })
            }, _toDisplayString(_ctx.$t('MPME')), 3)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: goToCompaniePage,
              class: _normalizeClass({
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': _ctx.$route.path === '/servicesFC'
              })
            }, _toDisplayString(_ctx.$t('SDE')), 3),
            _createElementVNode("button", {
              onClick: goToCompanieEPage,
              class: _normalizeClass({
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': _ctx.$route.path === '/servicesFCe'
              })
            }, _toDisplayString(_ctx.$t('EVA')), 3),
            _createElementVNode("button", {
              onClick: goToCompanieAPage,
              class: _normalizeClass({
                  'min-w-[300px] w-auto text-center m-[10px] py-[5px] px-[10px] rounded-[5px] border border-gray-500': true, 
                  'bg-cyan-600': _ctx.$route.path === '/servicesFCa'
              })
            }, _toDisplayString(_ctx.$t('ALL')), 3)
          ]),
          _createVNode(One_service, { services: services.value }, null, 8, ["services"])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})